import { Toaster } from '@agro1desenvolvimento/agro1-design-system/components/ui';
import { createRootRoute, Outlet } from '@tanstack/react-router';

import { AppSidebar } from '@/components/app-sidebar';

const TOAST_DURATION_MS = 2400;

const TOAST_CLASSES = {
  toast:
    'flex min-h-10 w-auto max-w-105 items-center justify-center gap-2 rounded-lg px-6 py-2 text-sm font-bold shadow-elevated',
  success: 'bg-positive-subtle text-positive',
  error: 'bg-negative-subtle text-negative',
  warning: 'bg-critical-subtle text-critical',
  info: 'bg-link-subtle text-link',
  icon: 'm-0 flex size-4.5 flex-none items-center justify-center',
  content: 'flex flex-col gap-0.5',
  title: 'text-sm font-bold',
  description: 'text-xs font-normal leading-[140%] text-body',
};

function RootLayout() {
  return (
    <div className="bg-canvas flex h-svh w-full overflow-hidden">
      <AppSidebar />
      <main className="min-w-0 flex-1 overflow-auto">
        <Outlet />
      </main>
      <Toaster
        duration={TOAST_DURATION_MS}
        position="bottom-center"
        theme="light"
        toastOptions={{ classNames: TOAST_CLASSES, unstyled: true }}
      />
    </div>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
});
